import { AulaDTO, ListAuleDTO } from './../../../model/newModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  AddUpdateAulaCommand,
  SearchAuleCommand,
} from 'src/app/model/command-model';
import {
  AbilitaDisabilitaCommand,
  EliminaCommand,
  GetCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class AAulaService {
  constructor(private http: HttpClient) {}

  abilitaDisabilita(id: number, isAbilita: boolean) {
    const command = new AbilitaDisabilitaCommand();
    command.id = id;
    command.active = isAbilita;
    return this.http.post<boolean>(
      ConstantsCLA.ABILITA_DISABILITA_AULA_URL,
      command
    );
  }

  save(newAula: AddUpdateAulaCommand) {
    return this.http.post<AddUpdateAulaCommand>(
      ConstantsCLA.CREA_AULA_URL,
      newAula
    );
  }

  update(updateAula: AddUpdateAulaCommand) {
    return this.http.post<AddUpdateAulaCommand>(
      ConstantsCLA.MODIFICA_AULA_URL,
      updateAula
    );
  }

  delete(idAula: number) {
    const command = new EliminaCommand();
    command.id = idAula;
    return this.http.post<AulaDTO>(ConstantsCLA.ELIMINA_AULA_URL, command);
  }

  getAula(idAula: number) {
    const command = new GetCommand();
    command.id = idAula;
    return this.http.post<AulaDTO>(ConstantsCLA.GET_AULA_URL, command);
  }

  search(abilitatoDisabilitato: string) {
    const command = new SearchAuleCommand();
    command.abilitatoDisabilitato = abilitatoDisabilitato;
    command.skip = 0;
    command.take = 10;
    return this.http.post<ListAuleDTO>(ConstantsCLA.SEARCH_AULA_URL, command);
  }

  previousPage(abilitatoDisabilitato: string, skip: number, take: number) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchAuleCommand();
    command.abilitatoDisabilitato = abilitatoDisabilitato;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListAuleDTO>(ConstantsCLA.SEARCH_AULA_URL, command);
  }

  nextPage(
    abilitatoDisabilitato: string,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchAuleCommand();
    command.abilitatoDisabilitato = abilitatoDisabilitato;
    command.skip = skipNew;
    command.take = take;
    return this.http.post<ListAuleDTO>(ConstantsCLA.SEARCH_AULA_URL, command);
  }

  goToPage(abilitatoDisabilitato: string, idVaiA: string, take: number) {
    const command = new SearchAuleCommand();
    command.abilitatoDisabilitato = abilitatoDisabilitato;
    command.skip = Number(idVaiA);
    command.take = take;
    return this.http.post<ListAuleDTO>(ConstantsCLA.SEARCH_AULA_URL, command);
  }
}
